import clsx from 'clsx'
import { ITableCellProps } from './types'
import styles from './styles.module.scss'

const TableCell = ({ children, variant = 'cell', align = 'left', ...props }: ITableCellProps) => {
  if (variant === 'headerCell')
    return (
      <th className={clsx(styles.cell, styles[align])} {...props}>
        {children}
      </th>
    )
  return (
    <td className={clsx(styles.cell, styles[align])} {...props}>
      {children}
    </td>
  )
}

export default TableCell
